<template>
  <div class="hello">
<router-view/>     
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    msg: String
  },
  mounted(){
  },
  methods:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
